
import React from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserProfile, Assignment, TimeEntry } from "./types";
import { UserHeader } from "./UserHeader";
import { UserInfoTab } from "./UserInfoTab";
import { AssignmentsTab } from "./AssignmentsTab";
import { TrackingTab } from "./TrackingTab";
import { DocumentsTab } from "./documents/DocumentsTab";
import { UserActions } from "./UserActions";

interface UserDetailsContentProps {
  user: UserProfile;
  assignments: Assignment[];
  timeEntries: TimeEntry[];
  loadingTimeEntries: boolean;
  isAdmin: boolean;
  onBack: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onAddAssignment: () => void;
  onFetchTimeEntries: () => void;
}

export const UserDetailsContent: React.FC<UserDetailsContentProps> = ({
  user,
  assignments,
  timeEntries,
  loadingTimeEntries,
  isAdmin,
  onBack,
  onEdit,
  onDelete,
  onAddAssignment,
  onFetchTimeEntries
}) => {
  return (
    <div className="min-h-screen bg-[#F8F8F8] flex flex-col">
      <UserHeader userName={user.name} onBack={onBack} />

      <div className="flex-1 p-4 pb-20">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-[#333333]">{user.name}</h2>
        </div>

        <Tabs defaultValue="info" className="w-full">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="info">Informations</TabsTrigger>
            <TabsTrigger value="assignments">Assignations</TabsTrigger>
            <TabsTrigger value="tracking" onClick={onFetchTimeEntries}>Pointages</TabsTrigger>
            <TabsTrigger value="documents">Documents</TabsTrigger>
          </TabsList>

          <TabsContent value="info" className="space-y-4">
            <UserInfoTab user={user} />
          </TabsContent>

          <TabsContent value="assignments" className="space-y-4">
            <AssignmentsTab 
              assignments={assignments} 
              onAddAssignment={onAddAssignment} 
            />
          </TabsContent>

          <TabsContent value="tracking" className="space-y-4">
            <TrackingTab 
              timeEntries={timeEntries} 
              loading={loadingTimeEntries} 
            />
          </TabsContent>

          <TabsContent value="documents" className="space-y-4">
            <DocumentsTab 
              userId={user.id} 
              isAdmin={isAdmin}
            />
          </TabsContent>
        </Tabs>
      </div>

      {isAdmin && <UserActions onEdit={onEdit} onDelete={onDelete} />}
    </div>
  );
};
